import {Component, OnInit} from '@angular/core';
import {ListaService} from '../../_services/lista.service';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NavService} from '../../_services/_nav.service';
import {Location} from '@angular/common';
import {ActivatedRoute, Params} from '@angular/router';
import {Modalidad} from '../../_models/modalidad';
import {ModalidadService} from '../../_services/modalidad.service';
import {ListaItem} from '../../_models/lista-item';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'app-canales-editar',
  templateUrl: 'modalidades-editar.component.html'
})

export class ModalidadesEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  modalidad: Modalidad;
  lisModalidades: Modalidad[] = [];
  tabSeleccionado = 'INFO';
  lisTipoCanal: SelectItem[] = [];
  formulario: FormGroup;
  submitted = false;
  listasCodigosFgaMaterial: SelectItem[] = [];
  listasCodigosFgaInmaterial: SelectItem[] = [];

  constructor(private lisServicio: ListaService,
              private nav: NavService,
              private modServicio: ModalidadService,
              private location: Location,
              private conServicio: ConfirmationService,
              private route: ActivatedRoute,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.carInformacionInicial =  true;
    this.route.params.subscribe(async (params: Params) => {
      if (params['id'] !== '' && params['id'] !== null && params['id'] !== undefined) {
        this.modServicio.obtenerPorId(params['id']).subscribe(async modalidad => {
          this.modalidad = modalidad;
          await this.carServicios();
          await this.cargarFormulario();
        });
      } else {
        await this.carServicios();
        await this.cargarFormulario();
      }
    });
  }

  async cargarFormulario() {
    this.formulario = this.fb.group({
      idModalidad: [this.modalidad ? this.modalidad.idModalidad : null],
      codigo: [this.modalidad ? this.modalidad.codigo : null, [Validators.required, Validators.maxLength(10)]],
      nombre: [this.modalidad ? this.modalidad.nombre : null, [Validators.required, Validators.maxLength(20)]],
      codigoShivam: [
        this.modalidad ? this.modalidad.codigoShivam : null,
        [Validators.required, Validators.maxLength(10), Validators.pattern('^[A-Za-z0-9]+$')]
      ],
      descripcion: [this.modalidad ? this.modalidad.descripcion : null, [Validators.required, Validators.maxLength(1000)]],
      indicadorHabilitado: [this.modalidad ? this.modalidad.indicadorHabilitado : true],
      indicadorConvenioFga: [ this.modalidad  ? this.modalidad.indicadorConvenioFga : true ],
      idFgaMaterial: [
        this.modalidad && this.modalidad.idFgaMaterial
          ? this.modalidad.idFgaMaterial
          : null
      ],
      idFgaInmaterial: [
        this.modalidad && this.modalidad.idFgaInmaterial
          ? this.modalidad.idFgaInmaterial
          : null
      ],
    });
    this.validarIndicadorConvenioFga();
    this.carInformacionInicial = false;
  }


  async carServicios() {
    const [modalidades, listasCodigosFgaMaterial, listasCodigosFgaInmaterial] = await forkJoin(
      this.modServicio.listadoModalidades(),
      this.lisServicio.getMasterDetails('ListasCodigosFgaMaterial'),
      this.lisServicio.getMasterDetails('ListasCodigosFgaInmaterial')
      ).toPromise();
    this.lisModalidades = modalidades;

    listasCodigosFgaMaterial.map( ( s: ListaItem ) => {
      this.listasCodigosFgaMaterial.push( { label: s.nombre, value: s.idLista } );
    } );

    listasCodigosFgaInmaterial.map( ( s: ListaItem ) => {
      this.listasCodigosFgaInmaterial.push( { label: s.nombre, value: s.idLista } );
    } );
  }


  onSubmit() {
    this.submitted = true;
    if (this.formulario.valid) {
        const modalidad = this.formulario.value;
        this.guardando = true;
        this.guardarModalidad(modalidad);
    }
  }

  guardarModalidad(modalidad: Modalidad) {
    if (modalidad.idModalidad !== '' && modalidad.idModalidad !== null && modalidad.idModalidad !== undefined) {
      this.modServicio.actualizar(modalidad).subscribe(rta => {
        this.modalidad = rta;
        this.guardando = false;
        this.nav.setMesage(2);
      }, error => {
        this.nav.setMesage(3);
        this.guardando = false;
      });
    } else {
      if ((this.lisModalidades.find(x => x.codigo === modalidad.codigo)) !== undefined) {
        this.nav.setMesage(0, {
          severity: 'info', summary: this.nav.buscarMensaje('LBL_INFORMACION'),
          detail: this.nav.buscarMensaje('MODALIDADES.LBL_CODIGOENUSO')
        });
        this.guardando = false;
      } else {
        this.modServicio.crear(modalidad).subscribe(rta => {
          this.modalidad = modalidad;
          this.modalidad.idModalidad = rta.idModalidad;
          this.modalidad.codigo = rta.codigo;
          this.f.idModalidad.setValue(rta.idModalidad);
          this.nav.setMesage(1);
          this.guardando = false;
          this.tabSeleccionado = 'FACT';
        }, error => {
          this.nav.setMesage(3);
          this.guardando = false;
        });
      }
    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.nav.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.nav.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

  get f() {
    return this.formulario.controls;
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'FACT';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'TAS';
        break;
      }
      case 3: {
        this.tabSeleccionado = 'AUT';
        break;
      }
      case 4: {
        this.tabSeleccionado = 'CAL';
        break;
      }
      default: {
        break;
      }
    }
  }

  cambiarTabSeleccionado(tab: string) {
    this.tabSeleccionado = tab;
  }

  validarIndicadorConvenioFga() {
    if (this.f.indicadorConvenioFga.value) {
       this.f.idFgaMaterial.setValidators([Validators.required]);
       this.f.idFgaMaterial.updateValueAndValidity();
       this.f.idFgaInmaterial.setValidators([Validators.required]);
       this.f.idFgaInmaterial.updateValueAndValidity();
    } else {
       this.f.idFgaMaterial.setValue(null);
       this.f.idFgaMaterial.setValidators(null);
       this.f.idFgaMaterial.updateValueAndValidity();
       this.f.idFgaInmaterial.setValue(null);
       this.f.idFgaInmaterial.setValidators(null);
       this.f.idFgaInmaterial.updateValueAndValidity();
    }
  }
}
